export const useSortIfArray = (value: string[] | string) => {
  return Array.isArray(value) ? useSortNumber(value) : value;
};

export const useSortNumber = (value: string[]) => value.sort((a: string, b: string) => +a - +b);
